export const errorCodes: {
  [index: number]: string;
} = {
  100: "We weren't able to retrieve your mailing address.",
  200: "We weren't able to find items in your cart.",
};
